"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserStatusWrapper = exports.StyledAvatarImage = exports.StyledAvatar = exports.EditOverlayWrapper = exports.EditOverlay = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _oxygenConstants = require("@8x8/oxygen-constants");
var _getSizeInPx = _interopRequireDefault(require("../utils/getSizeInPx"));
var _getFontSizeInPx = _interopRequireDefault(require("../utils/getFontSizeInPx"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var statusBorderColor = {
  available: '#189B55',
  away: '#F8AE1A',
  busy: '#CB2233',
  doNotDisturb: '#CB2233',
  onBreak: '#666666',
  onCall: '#CB2233',
  onDirectCall: '#189B55',
  offline: '#666666',
  workingOffline: '#F8AE1A'
};
var inAvatarElement = "\n  display: block;\n  position: absolute;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 50%;\n  content: '';\n";
var active = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &::after {\n    ", "\n    box-shadow: inset 0 0 0 2px ", ",\n      inset 0 0 0 4px ", ";\n  }\n"])), inAvatarElement, function (_ref) {
  var theme = _ref.theme;
  return theme.focusBorderColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.innerBorderColor;
});
var interactable = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  &:focus-visible {\n    outline: none;\n    ", "\n  }\n  &:hover {\n    &::before {\n      ", "\n      background: ", ";\n      opacity: 0.4;\n    }\n  }\n"])), active, inAvatarElement, function (_ref3) {
  var theme = _ref3.theme;
  return theme.hoverOverlayColor;
});
var getStatusBorder = function getStatusBorder(theme, size, userStatus) {
  var borderSize = [_oxygenConstants.avatarSize.size3xsmall, _oxygenConstants.avatarSize.size2xsmall].includes(size) ? 1 : 2;
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    box-shadow: inset 0 0 0 ", "px ", ",\n      inset 0 0 0 ", "px ", ";\n  "])), borderSize, statusBorderColor[userStatus], borderSize * 2, theme.innerBorderColor);
};
var statusBorder = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &::after {\n    ", "\n    ", "\n  }\n"])), inAvatarElement, function (_ref4) {
  var theme = _ref4.theme,
    size = _ref4.size,
    userStatus = _ref4.userStatus;
  return getStatusBorder(theme, size, userStatus);
});
var StyledAvatar = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  ", "\n\n  border-radius: 50%;\n  background: ", ";\n  > svg {\n    fill: ", ";\n  }\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  ", "\n  ", "\n  ", "\n"])), function (_ref5) {
  var hasBorder = _ref5.hasBorder,
    theme = _ref5.theme;
  return hasBorder && "border: 2px solid ".concat(theme.borderColor, ";");
}, function (_ref6) {
  var theme = _ref6.theme,
    size = _ref6.size;
  var sizeInPx = (0, _getSizeInPx["default"])({
    theme: theme,
    size: size
  });
  return "\n      height: ".concat(sizeInPx, ";\n      min-height: ").concat(sizeInPx, ";\n      width: ").concat(sizeInPx, ";\n      min-width: ").concat(sizeInPx, ";\n    ");
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.avatarBackgroundColor;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.placeholderIconColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.initialsColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.initialsFontFamily;
}, _getFontSizeInPx["default"], function (_ref11) {
  var hasStatusBorder = _ref11.hasStatusBorder;
  return hasStatusBorder && statusBorder;
}, function (_ref12) {
  var onClick = _ref12.onClick;
  return onClick && interactable;
}, function (_ref13) {
  var isActive = _ref13.isActive;
  return isActive && active;
});
exports.StyledAvatar = StyledAvatar;
var EditOverlay = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", ";\n  position: absolute;\n  background: ", ";\n  opacity: 0.85;\n  svg {\n    fill: ", ";\n    width: ", ";\n    height: ", ";\n  }\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])), function (_ref14) {
  var theme = _ref14.theme,
    size = _ref14.size;
  return "calc(0.3 * ".concat(theme["size".concat(size[0].toUpperCase() + size.slice(1))], ")");
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.editOverlayColor;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.editIconColor;
}, function (_ref17) {
  var size = _ref17.size,
    theme = _ref17.theme;
  return size === '5xl' ? theme.editIconLargeSize : theme.editIconSmallSize;
}, function (_ref18) {
  var size = _ref18.size,
    theme = _ref18.theme;
  return size === '5xl' ? theme.editIconLargeSize : theme.editIconSmallSize;
});
exports.EditOverlay = EditOverlay;
var EditOverlayWrapper = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  border-radius: 50%;\n"])));
exports.EditOverlayWrapper = EditOverlayWrapper;
var StyledAvatarImage = _styledComponents["default"].img(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  object-fit: cover;\n"])), _getSizeInPx["default"], _getSizeInPx["default"]);
exports.StyledAvatarImage = StyledAvatarImage;
var UserStatusWrapper = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  pointer-events: none;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n"])));
exports.UserStatusWrapper = UserStatusWrapper;